import Layout from "../components/layout/Layout";
import DashboardTabs from "../components/ui/DashboardTabs";
import { Tournament } from "src/components/WeekAtAGlance/IndividualTournament";
import LeagueSignUp from "src/components/Tournaments/LeagueSignUp";
import HorseRequestsManager from "src/components/HorseManagement/HorseRequestsManager";

function TournamentSignups({
  eventId,
  clubId,
  TournamentDate,
  devPort,
  waiverNotifications,
  managerMode,
  eventDetails,
}: {
  eventId: string;
  clubId: number;
  TournamentDate: string;
  devPort: string;
  waiverNotifications: boolean;
  managerMode: number;
  eventDetails: Tournament;
}) {
  //const [currentPage, setCurrentPage] = useState("signups");
  const currentPage = "/tournamentsignups";
  
  return (
    <Layout
      managerMode={managerMode}
      waiverNotifications={waiverNotifications}
      devPort={devPort}
    >
      <DashboardTabs
        currentPage={currentPage}
        managerMode={managerMode}
        gameMode="tournament"
        toReload={false}
        saveToDb={false}
      />
      {/* Horse Requests Manager for each league */}
      {managerMode === -1 && eventDetails.leagues.map((league) => (
        <HorseRequestsManager
          key={`horse-req-${league.tournament_id}`}
          devPort={devPort}
          clubId={clubId}
          eventType="tournaments"
          eventId={league.tournament_id}
          managerMode={managerMode}
        />
      ))}
      {eventDetails.leagues.map((league) => (
        <LeagueSignUp
          key={league.tournament_id}
          league={league}
          managerMode={managerMode}
          devPort={devPort}
          clubId={clubId}
        />
      ))}
    </Layout>
  );
}

export default TournamentSignups;
